import { c as _c } from "react/compiler-runtime";
import { Loader2 } from "lucide-react";
import { Suspense } from "react";
import { ThemeSwitcherClient } from "./client";
export function ThemeSwitcher() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<div className="flex h-9 items-center justify-center"><Loader2 className="h-4 w-4 animate-spin text-muted-foreground" /></div>}><ThemeSwitcherClient /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}